module.exports = WeatherMap;


//////////////////
// WEBPACK FOOTER
// external "WeatherMap"
// module id = 6DQx
// module chunks = 2 3